import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=4c1d15cd&scoped=true&"
import script from "./Modify.vue?vue&type=script&lang=js&"
export * from "./Modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1d15cd",
  null
  
)

export default component.exports